<template>
  <div
    class="tw-flex tw-h-11 tw-w-full tw-flex-row tw-flex-nowrap tw-items-center tw-justify-start tw-gap-2 tw-rounded-full tw-border tw-border-outline tw-px-4 tw-py-3 tw-outline-none"
    @click="inputFocus"
  >
    <AppIcon class="tw-fill-blue-gray-700" :size="20" icon="magnify" />
    <input
      v-model="search"
      class="tw-h-5 tw-w-full tw-text-body-1 tw-outline-none placeholder:tw-text-sm"
      ref="searchInput"
      :placeholder="placeholder"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      id="searchInput"
    />
    <span v-if="search" @click="clearInput">
      <AppIcon class="tw-cursor-pointer tw-fill-blue-gray-600" :size="20" icon="close" />
    </span>
  </div>
</template>
<script>
import { useUtil } from '@/plugins/util'
import { usePhysicianStore } from '@/store/pinia/physician'
import AppIcon from '@/v2/components/ui/icon/AppIcon.vue'
import * as amplitude from '@amplitude/analytics-browser'

export default {
  components: { AppIcon },
  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'Buscar paciente...',
    },
    focused: Boolean,
  },
  data() {
    return {
      search: this.value,
    }
  },
  watch: {
    value(val) {
      if (val !== this.search) {
        this.search = val
      }
    },
    search(val) {
      this.$emit('input', val)
    },
    focused(val) {
      if (val) {
        this.inputFocus()
      }
    },
  },
  methods: {
    inputFocus() {
      const util = useUtil()
      const physicianStore = usePhysicianStore()

      const userData = util.prepareAnalyticsUserProperties(physicianStore)
      amplitude.track('Clique no header', {
        button: 'Buscar paciente',
        buttonTitle: 'Buscar paciente',
        ...userData,
      })
      this.$refs.searchInput.focus()
    },
    clearInput() {
      this.search = ''
    },
  },
  mounted() {
    if (this.focused) {
      this.$nextTick(() => {
        this.inputFocus()
      })
    }
  },
}
</script>

<style scoped></style>
